import { useEffect, useRef } from "react";

export default function PodcastPlayer({
    episode,
    isPlaying,
    setIsPlaying
}) {

    const audioRef = useRef(null);

    //--------------------------------------------------
    /*
        useEffect(() => {
    
            if (!audioRef.current)
                return;
    
            if (isPlaying)
                audioRef.current.play();
    
            else
                audioRef.current.pause();
    
        }, [isPlaying]);
        */
    useEffect(() => {

        if (!audioRef.current)
            return;

        if (isPlaying) {
            audioRef.current
                .play()
                .catch(() => { });
        }
        else {
            audioRef.current.pause();
        }

    }, [isPlaying]);

    useEffect(() => {

        if (!audioRef.current)
            return;

        if (!episode) {
            audioRef.current.pause();
            return;
        }

        audioRef.current.load();
        audioRef.current.play();

    }, [episode]);

    return (

        <div className="podcast-player">

            {!episode ? (
                <>
                    <div className="font-raleway font-size-18 font-weight-400 txt-red text-justify line-height-125per">
                        No Episode Selected
                    </div>
                    <div className="font-raleway font-size-20l-18m-16s font-weight-600 txt-000 text-justify line-height-125per">
                        &nbsp;
                    </div>
                </>
            ) : (

                <>
                    <div className="font-raleway font-size-18 font-weight-400 txt-000 text-justify line-height-125per">
                        Now Playing Episode {episode.episode}
                    </div>
                    <div className="font-raleway font-size-20l-18m-16s font-weight-600 txt-000 text-justify line-height-125per">
                        {episode.title}
                    </div>
                </>
            )}

            <audio
                ref={audioRef}
                controls
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
            >
                {/*!episode ? (
                    <source
                    />
                ) : (
                    <source
                        src={episode.audioUrl}
                        type="audio/mpeg"
                    />
                )*/}
                {episode && (
                    <source
                        src={episode.audioUrl}
                        type="audio/mpeg"
                    />
                )}

            </audio>

        </div>

    );

}